<div class="status-bar-container">
  <div class="status-bar">
    <button type="button" class="search-form-toggler" (click)="onToggleFilterSort()">
      <span class="material-icons">search</span>
    </button>
    <span class="book-count">Book Count: {{ setCount() }} </span>
    <span> out of {{ totalCount() }} </span>
    @if(isLoggedIn()){
    <span class="add-button">
      <button mat-raised-button color="primary" name="newBtn" (click)="onNewBook()">Add
        Book</button></span>
    }
    <span>&nbsp;&nbsp;</span>
    <span>
      <mat-paginator  #paginator 
                      [length]="setCount()" 
                      (page)="onPageChange($event)"
                      [pageSize]="status().pageSize" 
                      [pageSizeOptions]="PAGE_SIZE_OPTIONS"
                      [pageIndex]="status().pageIndex" 
                      [showFirstLastButtons]="true" 
                      [hidePageSize]="false"
                      [showFirstLastButtons]="true"
      ></mat-paginator>
    </span>
  </div>
  @if(isLoggedIn()){
  <div class="layout-toggle">
    <span><button mat-raised-button color="primary" (click)="onToggleLayout()">
        <mat-icon>{{ status().isGridLayout ? 'view_list' : 'grid_view' }}</mat-icon>
        {{ status().isGridLayout ? 'Batch Edit' : 'Grid View' }}</button>
    </span>
  </div>
  }
</div>